import { useState } from "react";
import { useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { MapContexts, MergedProjectResponse } from "./InitialMapValues";

export default function useMapStates(defaultContext: MapContexts) {
  const [showMap, setShowMap] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const { clientId } = useParams<{ clientId: string }>();
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const [showDropdownMenu, setShowDropdownMenu] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupInfo, setPopupInfo] = useState<MergedProjectResponse>(
    defaultContext.popupInfo,
  );
  const [dataId, setDataId] = useState("");

  return {
    showMap,
    setShowMap,
    showAlert,
    setShowAlert,
    showDropdownMenu,
    setShowDropdownMenu,
    showPopup,
    setShowPopup,
    popupInfo,
    setPopupInfo,
    dataId,
    setDataId,
    clientId,
    isMobile,
  };
}
